import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AcGeoLocationComponent} from './ac-geo-location.component';
import {AcTextFieldModule} from '../ac-text-field/ac-text-field.module';
import {MatAutocompleteModule, MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {InfraPipesModule} from "../../pipes/infra.pipes.module";
import {InfraDirectivesModule} from "../../directives/infra.directives.module";
import {MatInputModule} from "@angular/material/input";
import {AcIconsModule} from "../ac-icons/ac-icons.module";
import {MatIconModule} from "@angular/material/icon";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        AcIconsModule,
        MatIconModule,
        InfraPipesModule,
        InfraDirectivesModule
    ],
    declarations: [
        AcGeoLocationComponent,
    ],
    exports: [
        AcGeoLocationComponent,
    ]
})
export class AcGeoLocationModule {
}
